import { render } from "./WebBotFlowSetting.vue?vue&type=template&id=23e39d2a&scoped=true"
import script from "./WebBotFlowSetting.vue?vue&type=script&lang=js"
export * from "./WebBotFlowSetting.vue?vue&type=script&lang=js"

import "./WebBotFlowSetting.vue?vue&type=style&index=0&id=23e39d2a&scoped=true&lang=scss"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23e39d2a"]])

export default __exports__